import { render } from "./S344849Legal.vue?vue&type=template&id=26e4004e"
const script = {}
script.render = render

export default script